/*=================================================
    summary: 學習總結    LUSeqNo: 25
             CanDoStatements

    remarks: 000 Tim 2022/01/07 Create
=================================================*/
import React, { useEffect, useState, useRef, useContext } from 'react'
import cssCanDoStatements from './CanDoStatements.module.scss'

import { LUCacheContext } from '../../LearningUnit.js'
import {ClientGatewayInPackage, GoogleShareToClassRoom, GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'

// import * as utilAudioLibs from '../../../Utils/TTS/AudioLibs'

// import GoogleShareToClassRoom from '../../../Utils/GShare.js'

const COMP_NAME = "CanDoStatements"

// #region const
const ANSWER_DATA_TYPE_CAN_DO_AUDIO = 5     // gAnsDataTypeEnum.CanDoAudio: 5  舊版存資料的 DataType    Tim22.01.10
// #endegion const

// #region Enumeration
const UpdateQuestionDataActionTypeEnum = {
    "DeleteAll": 1,             // 刪除整個 LU答案
    "DeleteQuestion": 2,        // 刪除這大題裡面的答案 EX: Compostion一頁。
    "DeleteAnswer": 3,          // 刪除這大題裡面的答案 EX: Compostion 其中一項(圖片 或 音檔)。
    "UpdateAnswer": 4           // 新增答案     FQ 需要一次新增多筆資料 QList 會傳一個以上  FQ: Homework Listening 一題有兩小題。
}
// #endregion Enumeration

// #region State Member Variables
let marrStateAudioStatus = []
// #endregion State Member Variables

// #region Member Variables
let mblnInitialized = false

let mobjCallParam = null
let mstrLUKey4LUCachedContext = ""  // 用於從LUCacheContext 取出 Cache的LU資料時 指出此LU時所需的Key
let mstrBookCatID = ""
let mstrLUCatSeqNo = ""

let mobjTestSheet = {
    "Dirty": false,
    "AnswerList": []
}

let mstrSubSectionTitleCN = ""
let marrDisplayQuestion = []
let mintPlayAudioIndex = -1
let mintAudioRecordIndex = -1
// #endregion Member Variables

function CanDoStatements(props) 
{
    console.log(COMP_NAME + ".Begin:", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [audioStatusArray, setAudioStatusArray] = useState([])
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region Init Context Ref
    // History, Temp, AccountStorage, 都是 Cached 在這裏
    let mobjLUCacheContext = useContext(LUCacheContext)
    console.log("mobjLUCacheContext: ", mobjLUCacheContext)
    // #endregion Init Context Ref

    // #region First Launch
    if (!mblnInitialized) 
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
        mblnInitialized = true

        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Update audioStatusArray
    useEffect(() => {
        marrStateAudioStatus = audioStatusArray

        console.log(COMP_NAME + ".Update audioStatusArray: marrStateAudioStatus: ", marrStateAudioStatus)
    }, [audioStatusArray])

    // #region useEffect
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
            window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
            window.AudioLibs.StopAudio()

            mblnInitialized = false
            mobjCallParam = null
            mstrLUCatSeqNo = ""
            mintPlayAudioIndex = -1
            mintAudioRecordIndex = -1
            mstrSubSectionTitleCN = ""

            setAudioStatusArray([])
            setUpdateDataTime(0)
            mrefCleanUp.current()
        }
    }, [props.LUInfo])
    // #endregion useEffect

    // #region Painted Me
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function PaintedMe()
    {
        // console.log(COMP_NAME + ".PaintedMe: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".PaintedMe BEGIN")
        mstrLUKey4LUCachedContext = "LU" + props.LUInfo.LUCatSeqNo // 用於Cache LU資料時 指出此LU的Key
        mstrLUCatSeqNo = props.LUInfo.LUCatSeqNo

        console.log(COMP_NAME + ".PaintedMe mstrLUKey4LUCachedContext: ", mstrLUKey4LUCachedContext)
        console.log(COMP_NAME + ".PaintedMe mstrLUCatSeqNo: ", mstrLUCatSeqNo)

        RegisterAudioEvent()

        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            mstrSubSectionTitleCN = props.SubSectionDef.MajorName
        }
        else
        {
            mstrSubSectionTitleCN = props.SubSectionDef.MinorName
        }

        let objAccountStorage = mobjLUCacheContext.AccountStorage[mstrLUKey4LUCachedContext]

        console.log(COMP_NAME + ".PaintedMe objAccountStorage: ", objAccountStorage)
        if (
            (typeof (objAccountStorage) === 'undefined') || 
            (objAccountStorage === null) || 
            (typeof (objAccountStorage.AnswerList) === 'undefined') || 
            (objAccountStorage.AnswerList === null) || 
            (objAccountStorage.AnswerList.length < 0) ||
            (typeof (objAccountStorage.LessonID) === 'undefined') || 
            (objAccountStorage.LessonID === null) || 
            (parseInt(objAccountStorage.LessonID) <= 0) || 
            (objAccountStorage.LessonID !== props.LessonID)
            )
        {
            console.log("need to get AccountStorage")

            GetPrerequisiteDataProcessBegin()
        }
        else
        {
            console.log("need Not to get AccountStorage")
            GetPrerequisiteDataProcessEnd()
        }

        RegisterLanguageChangeHandler()
        RegisterGlossaryCallback()
        setUpdateDataTime(new Date().getTime())
    } // end of PaintedMe

    /*===========================================
    summary: componentWillUnmount 程式離開 處理離開流程
    remarks: 000 Jeff 2022/01/13 Create  Tim幫忙註解
    ===========================================*/
    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")

        UnregisterLanguageChangeHandler()
        UnregisterGlossaryCallback()
    } // end of PaintedMe
    // #endregion Painted Me

    // #region OnTapHandler
    /*===========================================
    summary: App 點選 GoogleClassroom 元件
    remarks: 000 Tim 2022/01/07 Create
             001 Tim 2023/06/14 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function Share2GoogleClassroom4AppOnTapHandler()
    {
        // console.log(COMP_NAME + ".Share2GoogleClassroom4AppOnTapHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".Share2GoogleClassroom4AppOnTapHandler BEGIN")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(props.LUInfo.LUCatSeqNo)
        console.log("Share2GoogleClassroom4AppOnTapHandler strUrl: ", encodeURIComponent(strUrl))

        // In App
        let intAction = window.gConst.ACTION_OEPN_APP_SHARE_WITH_URL
        let intPositionX = 54 // 視窗的小箭頭位置
        let intPositionY = 112 // 視窗的小箭頭位置

        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&Url=" + encodeURIComponent(strUrl)
        strQueryString += "&PosX=" + intPositionX.toString()
        strQueryString += "&PosY=" + intPositionY.toString()

        console.log("Share2GoogleClassroom4AppOnTapHandler strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of Share2GoogleClassroom4AppOnTapHandler

    /*===========================================
    summary: 點選 錄音
    remarks: 000 Tim 2022/01/10 Create
    ===========================================*/
    function AudioRecordOnTapHandler(QuestionIndex, StateAudioStatusArray)
    {
        // console.log(COMP_NAME + ".AudioRecordOnTapHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".AudioRecordOnTapHandler BEGIN")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // 先停止播放
        let arrAudioStatus = JSON.parse(JSON.stringify(StateAudioStatusArray))
        arrAudioStatus[mintPlayAudioIndex] = window.gAudioStatusEnum.Stop
        setAudioStatusArray(arrAudioStatus)

        mintPlayAudioIndex = -1

        window.AudioLibs.StopAudio()

        let blnCanSupport = true
        if (
            (window.gSession.App.BrowserType4LogTrace === GlobalLibs.BrowserTypeEnum.Edge) ||
            (window.gSession.App.BrowserType4LogTrace === GlobalLibs.BrowserTypeEnum.ChromiumEdge)
            )
        {
            blnCanSupport = false
        } // end of if (window.gSession.App.BrowserType4LogTrace === GlobalLibs.BrowserTypeEnum.ChromiumEdge)

        if (blnCanSupport)
        {
            // 再 開啟 錄音視窗
            mintAudioRecordIndex = QuestionIndex

            let objCallbackData = {
                "Action": "AudioRecordingWindowOpen",
                "CallbackRef": AudioRecordingWindowCallback,
            }
            console.log("objCallbackData:", objCallbackData)
            props.CallbackRef(objCallbackData)
        } // end of if (blnCanSupport)
        else
        {
            let objAlertObject = {
                Header: window.gAppUI.MSG_Alert_Title_Google_SR_NotSupport,
                Body: window.gAppUI.MSG_Alert_Msg_Audio_Record_NotSupport,
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }
            ShowAlert(objAlertObject)
        } // end of else
    } // end of AudioRecordOnTapHandler

    /*===========================================
    summary: 點選 聲音播放
    remarks: 000 Tim 2022/01/10 Create
    ===========================================*/
    function AudioPlayOnTapHandler(AudioUrl, QuestionIndex, StateAudioStatusArray)
    {
        // console.log(COMP_NAME + ".AudioPlayOnTapHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".AudioPlayOnTapHandler BEGIN")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let arrAudioStatus = JSON.parse(JSON.stringify(StateAudioStatusArray))
        if (arrAudioStatus[QuestionIndex] === window.gAudioStatusEnum.Paused)
        {
            window.AudioLibs.Play()
        }
        else
        {
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadAudioData)
            window.AudioLibs.PlayAudio(AudioUrl)
        }

        if (mintPlayAudioIndex !== QuestionIndex)
        {
            arrAudioStatus[mintPlayAudioIndex] = window.gAudioStatusEnum.Stop
        }

        arrAudioStatus[QuestionIndex] = window.gAudioStatusEnum.Playing
        mintPlayAudioIndex = QuestionIndex
        setAudioStatusArray(arrAudioStatus)
    } // end of AudioPlayOnTapHandler

    /*===========================================
    summary: 點選 聲音停止
    remarks: 000 Tim 2022/01/10 Create
    ===========================================*/
    function AudioStopOnTapHandler(QuestionIndex, StateAudioStatusArray)
    {
        // console.log(COMP_NAME + ".AudioPlayOnTapHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".AudioPlayOnTapHandler BEGIN")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let arrAudioStatus = JSON.parse(JSON.stringify(StateAudioStatusArray))
        arrAudioStatus[QuestionIndex] = window.gAudioStatusEnum.Stop
        setAudioStatusArray(arrAudioStatus) 

        mintPlayAudioIndex = -1

        window.AudioLibs.StopAudio()
    } // end of AudioStopOnTapHandler

    /*===========================================
    summary: 點選 聲音暫停
    remarks: 000 Tim 2022/01/10 Create
    ===========================================*/
    function AudioPauseOnTapHandler(QuestionIndex, StateAudioStatusArray)
    {
        // console.log(COMP_NAME + ".AudioPauseOnTapHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".AudioPauseOnTapHandler BEGIN")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let arrAudioStatus = JSON.parse(JSON.stringify(StateAudioStatusArray))
        arrAudioStatus[QuestionIndex] = window.gAudioStatusEnum.Paused
        setAudioStatusArray(arrAudioStatus)     

        window.AudioLibs.PauseAudio()
    } // end of AudioPauseOnTapHandler

    /*===========================================
    summary: 點選 刪除音檔
    remarks: 000 Tim 2022/01/10 Create
    ===========================================*/
    function DeleteOnTapHandler(QuestionIndex, StateAudioStatusArray)
    {
        // console.log(COMP_NAME + ".DeleteOnTapHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".DeleteOnTapHandler BEGIN")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // 先停止播放
        let arrAudioStatus = JSON.parse(JSON.stringify(StateAudioStatusArray))
        arrAudioStatus[mintPlayAudioIndex] = window.gAudioStatusEnum.Stop
        setAudioStatusArray(arrAudioStatus)

        mintPlayAudioIndex = -1

        window.AudioLibs.StopAudio()

        // 再 刪除 資料
        marrDisplayQuestion[QuestionIndex].AudioUrl = ""
        mobjTestSheet.AnswerList[QuestionIndex].AudioFN = ""
        mobjTestSheet.Dirty = true
        console.log("mobjTestSheet: ", mobjTestSheet)

        mobjCallParam = {
            "BookCategoryID": mstrBookCatID,           
            "LessonID": props.LessonID,
            "LUSeqNo": window.gDCPLUEnum.LessonGoals,   // 存答案 借用 LessonGoals LUSeqNo 去存 (舊版機制)      Tim22.01.10
            "ActionType": UpdateQuestionDataActionTypeEnum.DeleteAnswer,
            "QList": []
        }

        let intExternalID = parseInt(marrDisplayQuestion[QuestionIndex].CDSQSeqNo)
        
        let objStorage = {
            "ExternalID": intExternalID,
            "AnsDataType": ANSWER_DATA_TYPE_CAN_DO_AUDIO,
            "Data": ""
        }
        mobjCallParam.QList.push(objStorage)

        SaveAccountStorageByBase64ForSencha()
    } // end of DeleteOnTapHandler
    // #endregion OnTapHandler

    // #region Other Handler
    /*===========================================
    summary: 語言設定 改變 事件
    remarks: 000 Jeff 2022/01/13 Create    Tim幫忙註解
             000 Tim 2022/01/13 實作內容
    ===========================================*/
    function LanguageOnChangeHandler()
    {
        console.log(COMP_NAME + ".LanguageOnChangeHandler: ")

        // 重新產生 mstrSubSectionTitleCN ＆ DisplayQuestion
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            mstrSubSectionTitleCN = props.SubSectionDef.MajorName
        }
        else
        {
            mstrSubSectionTitleCN = props.SubSectionDef.MinorName
        }

        marrDisplayQuestion = FormatCDSQuestionData(props.LUInfo, mobjTestSheet)

        setUpdateDataTime(new Date().getTime())
    } // end of LanguageOnChangeHandler

    /*===========================================
    summary: 播放聲音 結束事件
    remarks: 000 Tim 2022/01/10 Create
    ===========================================*/
    function PlayAudioEndHandler()
    {
        // console.log(COMP_NAME + ".PlayAudioEndHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".PlayAudioEndHandler BEGIN")

        let arrAudioStatus = JSON.parse(JSON.stringify(marrStateAudioStatus))
        arrAudioStatus[mintPlayAudioIndex] = window.gAudioStatusEnum.Stop
        setAudioStatusArray(arrAudioStatus) 

        mintPlayAudioIndex = -1
    } // end of PlayAudioEndHandler

    /*===========================================
    summary: 聲音檔 讀取完畢
    remarks: 000 Tim 2022/01/10 Create
    ===========================================*/
    function PlayAudioCanPlayHandler()
    {
        // console.log(COMP_NAME + ".PlayAudioCanPlayHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".PlayAudioCanPlayHandler BEGIN")
        CloseLoadingMask()
    } // end of PlayAudioCanPlayHandler
    // #endregion Other Handler

    // #region LoadingMask and Alert
    /*===========================================
    summary: 開啟 LoadingMask
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log("OpenLoadingMask: ", LoadingMsg)

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 LoadingMask
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2022/12/13 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        let objCallbackData = {
            "Action": "ShowAlertWindow",
            "AlertObject": AlertObject
        }
        props.CallbackRef(objCallbackData)
    } // end of ShowAlert
    // #endregion LoadingMask and Alert

    // #region ComponentCallback
    /*===========================================
    summary: 錄音視窗 Callback
    remarks: 000 Tim 2022/01/10 Create
    ===========================================*/
    function AudioRecordingWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".AudioRecordingWindowCallback.CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "AudioRecordingWindowCloseWithoutResult")
        {
            console.log("AudioRecordingWindowCloseWithoutResult")

            // 因為開啟AudioRecordingWindow時 Audio Event被註冊過去 所以關閉AudioRecordingWindow時 要再註冊回此
            window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        }
        else if (CallbackObj.Action === "AudioRecordingWindowCloseWithResult")
        {
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadAudioData)

            // 因為開啟AudioRecordingWindow時 Audio Event被註冊過去 所以關閉AudioRecordingWindow時 要再註冊回此
            window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
            
            console.log("AudioRecordingWindowCloseWithResult")
            console.log("Audio Base64: ", CallbackObj.AudioBase64)
            UserReordedGotton(CallbackObj.AudioBase64)
        }
    } // end of AudioRecordingWindowCallback
    // #endregion ComponentCallback

    // #region Component Callback
    function GlossaryWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".GlossaryWindowCallback.CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "CloseShowGlossary")
        {
            console.log("GlossaryWindowCallback.CloseShowGlossary")
            RegisterAudioEvent() // 因為開啟GlossaryWindow時 Audio Event被註冊過去 所以關閉GlossaryWindow時 要再註冊回此
        }
    }
    // #endregion Component Callback

    // #region Other Functions

    function RegisterAudioEvent()
    {
        console.log(COMP_NAME + ".RegisterAudioEvent")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioCanPlayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
    }

	function RegisterGlossaryCallback()
    {
        console.log(COMP_NAME + ".RegisterGlossaryCallback: ")
        // 因為ToolBarTopUnit點擊Glossary開啟後 會搶走AudioEnded, AudioCanPlay事件 所以如果LU有使用Audio Event 就必須在Glossary關閉時 需呼叫mobjCallerInfoForGlossaryWindow.CallbackRef 觸發 讓Audio Event再次註冊到LU
        let objCallbackData = {
            "Action": "RegisterGlossaryCallback",
            "CallbackRef": GlossaryWindowCallback
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterGlossaryCallback()
    {
        console.log(COMP_NAME + ".UnregisterGlossaryCallback: ")
        let objCallbackData = {
            "Action": "UnregisterGlossaryCallback"
        }
        props.CallbackRef(objCallbackData)
    } 

    /*===========================================
    summary: 註冊 語言改變事件
    remarks: 000 Jeff 2022/01/13 Create  Tim幫忙註解
    ===========================================*/
    function RegisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    } // end of RegisterLanguageChangeHandler

    /*===========================================
    summary: 反註冊 語言改變事件
    remarks: 000 Jeff 2022/01/13 Create  Tim幫忙註解
    ===========================================*/
    function UnregisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".UnregisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "UnregisterLanguageChangeHandler"
        }
        props.CallbackRef(objCallbackData)
    } // end of UnregisterLanguageChangeHandler
    
    /*===========================================
    summary: 取得 必要資料 流程 開始
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function GetPrerequisiteDataProcessBegin()
    {
        console.log(COMP_NAME + ".GetPrerequisiteDataProcessBegin")
        // 1. GetAccountStorageForSencha

        mobjCallParam = {
            "BookCategoryID": mstrBookCatID,
            "LessonID": props.LessonID
        }
        GetAccountStorageForSencha()
    } // end of GetPrerequisiteDataProcessBegin

    /*===========================================
    summary: 取得 必要資料 流程 結束
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function GetPrerequisiteDataProcessEnd()
    {
        console.log(COMP_NAME + ".GetPrerequisiteDataProcessEnd")

        SetTestSheetObject()

        marrDisplayQuestion = FormatCDSQuestionData(props.LUInfo, mobjTestSheet)
        InitAudioStatusArray(marrDisplayQuestion)

        setUpdateDataTime(new Date().getTime())
    } // end of GetPrerequisiteDataProcessEnd

    /*===========================================
    summary: 設定 目前 答案物件
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function SetTestSheetObject()
    {
        // console.log(COMP_NAME + ".SetTestSheetObject: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".SetTestSheetObject BEGIN")

        console.log("mstrLUKey4LUCachedContext: ", mstrLUKey4LUCachedContext)
        console.log("mobjLUCacheContext.AccountStorage: ", mobjLUCacheContext.AccountStorage[mstrLUKey4LUCachedContext])

        mobjTestSheet.Dirty = false
        mobjTestSheet.AnswerList = []

        let arrTempAnswer = mobjLUCacheContext.AccountStorage[mstrLUKey4LUCachedContext].AnswerList
        let objTempAnswer = null

        // QList: [
        //     AnsDataType: 5
        //     Data: "CanDo_03_03001_01_001_815_1641539087471.mp3"
        //     DeviceLastModifiedTime: 1641539097
        //     ExternalID: 1
        //     IsCheck: 1
        // ]

        let intIndex = 0
        let intCount = props.LUInfo.Goals.length

        let objAnswer = null

        for (intIndex = 0; intIndex < intCount; intIndex++)
        {
            let strCDSQSeqNo = props.LUInfo.Goals[intIndex].GoalSN
            
            objTempAnswer = arrTempAnswer.find(AnswerData => parseInt(AnswerData.ExternalID) === parseInt(strCDSQSeqNo))

            console.log("objTempAnswer: ", objTempAnswer)

            if (
                (typeof(objTempAnswer) !== 'undefined') &&
                (objTempAnswer !== null)
                )
            {
                objAnswer = {
                    "CDSQSeqNo": objTempAnswer.ExternalID,
                    "AudioFN": objTempAnswer.Data,
                    "AnsDataType": objTempAnswer.AnsDataType
                }
            }
            else
            {
                objAnswer = {
                    "CDSQSeqNo": parseInt(strCDSQSeqNo).toString(),
                    "AudioFN": null,
                    "AnsDataType": null
                }
            }

            console.log("objAnswer: ", objAnswer)
            mobjTestSheet.AnswerList.push(objAnswer)
        } // end of for (intIndex4SQ = 0;
        console.log(COMP_NAME + ".SetTestSheetObject END mobjTestSheet: ", mobjTestSheet)
    } // end of SetTestSheetObject

    /*===========================================
    summary: 初始化 選擇題 顯示資料
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function FormatCDSQuestionData(LUInfo, TestSheet)
    {
        // console.log(COMP_NAME + ".FormatCDSQuestionData: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".FormatCDSQuestionData LUInfo: ", LUInfo)
        console.log(COMP_NAME + ".FormatCDSQuestionData TestSheet: ", TestSheet)

        let arrGoals = LUInfo.Goals
        let arrDisplayQuestion = []
        let objDisplayQuestion = null

        let intCDSIndex = 0
        let intCDSCount = arrGoals.length
        let arrAnswer = TestSheet.AnswerList
        let objAnswer = null

        for (intCDSIndex = 0; intCDSIndex < intCDSCount; intCDSIndex++)
        {
            objDisplayQuestion = {
                "CDSQSeqNo": arrGoals[intCDSIndex].GoalSN,
                "QuestionText": "",
                "AudioUrl": null
            }

            if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
            {
                objDisplayQuestion.QuestionText = arrGoals[intCDSIndex].MajorGoal
            }
            else
            {
                objDisplayQuestion.QuestionText = arrGoals[intCDSIndex].MinorGoal
            }

            let intCDSQSeqNo = parseInt(arrGoals[intCDSIndex].GoalSN)

            // 找出 使用者 選擇的答案
            objAnswer = arrAnswer.find(AnswerData => (parseInt(AnswerData.CDSQSeqNo) === intCDSQSeqNo))
                
            if (
                (typeof(objAnswer) !== 'undefined') &&
                (objAnswer !== null) &&
                (typeof(objAnswer.AudioFN) !== 'undefined') &&
                (objAnswer.AudioFN !== null) &&
                (objAnswer.AudioFN !== '')
                )
            {
                // gAnsDataTypeEnum.CanDoAudio
                objDisplayQuestion.AudioUrl = GetAccountStorageUrl(window.gSession.Acc.ID, objAnswer.AudioFN)
            } // end of if (objAnswer !== null)
                
            arrDisplayQuestion.push(objDisplayQuestion)
        } // end of for (intCQIndex = 0;

        console.log(COMP_NAME + ".FormatCQQuestionData END arrDisplayQuestion: ", arrDisplayQuestion)

        return arrDisplayQuestion
    } // end of FormatCDSQuestionData

    /*===========================================
    summary: 取得 舊版 使用者資料 的 Url
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function GetAccountStorageUrl (AccountID, FileName)
    {
        console.log("GetAccountStorageUrl: ", AccountID, FileName)
        
        // http://54.165.87.220/FileServer/AccountStorage/Account_192/ImgAns01_01001_026_192_1461297672.jpg

        let strASFolder = "Account_" + AccountID + "/"
        console.log("Not InApp: ", window.gConfig.AccountStorageUrl, strASFolder)
        
        let strUrl = window.gConfig.AccountStorageUrl + strASFolder + FileName

        console.log("GetAccountStorageUrl END strUrl: ", strUrl)
        return strUrl
    } // end of GetAccountStorageUrl

    /*===========================================
    summary: 初始化 音檔狀態
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function InitAudioStatusArray(DisplayQuestion)
    {
        let arrAudioStatus = []
        DisplayQuestion.forEach(() => {
            arrAudioStatus.push(window.gAudioStatusEnum.Stop)
        })

        console.log(COMP_NAME + ".InitAudioStatusArray arrAudioStatus: ", arrAudioStatus)

        setAudioStatusArray(arrAudioStatus)
    } // end of InitAudioStatusArray

    /*===========================================
    summary: 使用者 音檔 錄製完畢 取得資料
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function UserReordedGotton (AudioBase64)
    {
        console.log(COMP_NAME + ".UserReordedGotton: ", AudioBase64.length)
        console.log(COMP_NAME + ".UserReordedGotton mintAudioRecordIndex: ", mintAudioRecordIndex)

        if (AudioBase64 !== "")
        {
            // console.log("mobjTestSheet: ", JSON.parse(JSON.stringify(mobjTestSheet)))

            // 先更新 資料
            marrDisplayQuestion[mintAudioRecordIndex].AudioUrl = AudioBase64
            mobjTestSheet.AnswerList[mintAudioRecordIndex].AudioFN = AudioBase64
            mobjTestSheet.Dirty = true
            console.log("mobjTestSheet: ", mobjTestSheet)
            
            // 上傳資料到後端
            mobjCallParam = {
                "BookCategoryID": mstrBookCatID,
                "LessonID": props.LessonID,
                "LUSeqNo": window.gDCPLUEnum.LessonGoals,   // 存答案 借用 LessonGoals LUSeqNo 去存 (舊版機制)      Tim22.01.10
                "ActionType": UpdateQuestionDataActionTypeEnum.UpdateAnswer,
                "QList": []
            }

            let intExternalID = parseInt(marrDisplayQuestion[mintAudioRecordIndex].CDSQSeqNo)
            let strFileName = GenerateLUFileName(mstrBookCatID
                , props.LessonID
                , window.gDCPLUEnum.LessonGoals
                , intExternalID, window.gSession.Acc.ID)
            
            let objStorage = {
                "ExternalID": intExternalID,
                "AnsDataType": ANSWER_DATA_TYPE_CAN_DO_AUDIO,
                "Data": strFileName,
                "AttachedFile": AudioBase64
            }
            mobjCallParam.QList.push(objStorage)

            SaveAccountStorageByBase64ForSencha()
        }

        CloseLoadingMask()
        mintAudioRecordIndex = -1
    } // end of UserReordedGotton

    /*===========================================
    summary: 產生 LU 答案 檔名
    remarks: 000 Tim 2022/01/10 由 Sencha搬移過來改寫
    ===========================================*/
    function GenerateLUFileName (BookCategoryID, LessonID, LUCatSeqNo, QSeqNo, AccountID) 
    {
        console.log(COMP_NAME + ".GenerateLUFileName: ", BookCategoryID, LessonID, LUCatSeqNo, QSeqNo, AccountID)

        let strBookCategoryID = BookCategoryID
        let strLessonID = LessonID
        let strLUCatSeqNo = LUCatSeqNo.toString().PadLeft(2)  // 左邊補零 Format "01"
        let strQSeqNo = QSeqNo.toString().PadLeft(3)    // 左邊補零 Format "001"
        let intTime = new Date().getTime()

        let strPrefix = "CanDo"
        let strSuffix = ".mp3"

        let strFileName = strPrefix
        strFileName += "_" + strBookCategoryID
        strFileName += "_"  + strLessonID
        strFileName += "_" + strLUCatSeqNo
        strFileName += "_" + strQSeqNo
        strFileName += "_" + AccountID
        strFileName += "_" + intTime
        strFileName += strSuffix

        return strFileName
    } // end of GenerateLUFileName

    /*===========================================
    summary: Submit後 更新 Cache資料
    remarks: 000 Tim 2022/01/10 Create
    ===========================================*/
    function UpdateCacheSinceSubmit(CallParam)
    {
        console.log(COMP_NAME + ".UpdateCacheSinceSubmit: CallParam: ", CallParam)

        console.log("UpdateCacheSinceSubmit mobjLUCacheContext.AccountStorage: ", mobjLUCacheContext.AccountStorage)

        let intQuestionIndex = -1
        let objAnswer = {
            "AnsDataType": ANSWER_DATA_TYPE_CAN_DO_AUDIO,
            "ExternalID": CallParam.QList[0].ExternalID,
            "Data": CallParam.QList[0].Data,
            "DeviceLastModifiedTime": new Date().getTime(),
            "IsCheck": 1
        }

        if (CallParam.ActionType === UpdateQuestionDataActionTypeEnum.UpdateAnswer)
        {
            // 新增答案
            objAnswer.IsCheck = 1
            intQuestionIndex = mobjLUCacheContext.AccountStorage[mstrLUKey4LUCachedContext].AnswerList.findIndex(AnswerData => (parseInt(AnswerData.ExternalID) === parseInt(CallParam.QList[0].ExternalID)))

            console.log("UpdateCacheSinceSubmit intQuestionIndex: ", intQuestionIndex)

            if (
                (typeof(intQuestionIndex) !== 'undefined') &&
                (intQuestionIndex !== null) &&
                (parseInt(intQuestionIndex) >= 0)
                )
            {
                // 曾經有資料
                mobjLUCacheContext.AccountStorage[mstrLUKey4LUCachedContext].AnswerList[intQuestionIndex] = objAnswer
            }
            else
            {
                // 沒搜尋到
                mobjLUCacheContext.AccountStorage[mstrLUKey4LUCachedContext].AnswerList.push(objAnswer)
            }
        } // end of if (CallParam.ActionType === UpdateQuestionDataActionTypeEnum.UpdateAnswer)
        else if (CallParam.ActionType === UpdateQuestionDataActionTypeEnum.DeleteAnswer)
        {
            // 刪除這大題裡面的答案 EX: Compostion 其中一項(圖片 或 音檔)。
            objAnswer.IsCheck = 0
            intQuestionIndex = mobjLUCacheContext.AccountStorage[mstrLUKey4LUCachedContext].AnswerList.findIndex(AnswerData => (parseInt(AnswerData.ExternalID) === parseInt(CallParam.QList[0].ExternalID)))
            
            console.log("UpdateCacheSinceSubmit intQuestionIndex: ", intQuestionIndex)
            if (
                (typeof(intQuestionIndex) !== 'undefined') &&
                (intQuestionIndex !== null) &&
                (parseInt(intQuestionIndex) >= 0)
                )
            {
                mobjLUCacheContext.AccountStorage[mstrLUKey4LUCachedContext].AnswerList[intQuestionIndex] = objAnswer
            }
        } // end of else if (CallParam.ActionType === UpdateQuestionDataActionTypeEnum.DeleteAnswer)

        console.log("UpdateCacheSinceSubmit END mobjLUCacheContext.AccountStorage: ", mobjLUCacheContext.AccountStorage)

        setUpdateDataTime(new Date().getTime())
    } // end of UpdateCacheSinceSubmit
    // #endregion Other Functions

    // #region Get ClassName and Style
    /*===========================================
    summary: 取得 CheckedIcon Cls
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function GetCheckedIconCls(AudioUrl)
    {
        let objCls = cssCanDoStatements.divUncheckIcon

        if (
            (typeof(AudioUrl) !== 'undefined') &&
            (AudioUrl !== null) &&
            (AudioUrl !== '')
            )
        {
            objCls = cssCanDoStatements.divCheckedIcon
        }

        return objCls
    } // end of GetCheckedIconCls
    // #endregion Get ClassName and Style

    // #region Web Service After Process
    /*===========================================
    summary: 儲存舊版使用者 資料 後續流程
    remarks: 000 Tim 2022/01/10 Create
    ===========================================*/
    function SaveAccountStorageByBase64ForSenchaAfterProcess()
    {
        // console.log(COMP_NAME + ".SaveAccountStorageByBase64ForSenchaAfterProcess: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".SaveAccountStorageByBase64ForSenchaAfterProcess BEGIN")

        UpdateCacheSinceSubmit(mobjCallParam)

        mobjCallParam = null
    } // end of SaveAccountStorageByBase64ForSenchaAfterProcess

    /*===========================================
    summary: 取得舊版使用者 資料 後續流程
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function GetAccountStorageForSenchaAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".GetAccountStorageForSenchaAfterProcess: ", ReturnData)

        let arrLUList = []
        if (
            (typeof(ReturnData) !== 'undefined') &&
            (ReturnData !== null) &&
            (ReturnData !== '')
            )
        {
            arrLUList = ReturnData.LUList
        }

        // 這邊 借用 window.gDCPLUEnum.LessonGoals 的 LUSeqNo 去存取 舊版使用者資料
        let objLUAnswer = arrLUList.find(LUData => parseInt(LUData.LUSeqNo) === window.gDCPLUEnum.LessonGoals)
        let objAccountStorage = {
            "LessonID": props.LessonID,
            "AnswerList": []
        }
        
        if (
            (typeof(objLUAnswer) !== 'undefined') &&
            (objLUAnswer !== null)
            )
        {
            console.log(COMP_NAME + ".GetAccountStorageForSenchaAfterProcess objLUAnswer: ", objLUAnswer)
            objAccountStorage.AnswerList = objLUAnswer.QList
        }

        console.log(COMP_NAME + ".GetAccountStorageForSenchaAfterProcess objAccountStorage: ", objAccountStorage)

        // 更新 Cache
        mobjLUCacheContext.AccountStorage[mstrLUKey4LUCachedContext] = objAccountStorage
        
        console.log("完成 Step 1")
        GetPrerequisiteDataProcessEnd()

        mobjCallParam = null
    } // end of GetAccountStorageForSenchaAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 取得舊版使用者 資料
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function GetAccountStorageForSencha()
    {
        console.log(COMP_NAME + ".GetAccountStorageForSencha: ", props.LUInfo.LUCatSeqNo)

        let objRetryFuncRef = GetAccountStorageForSencha
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetAccountStorageForSenchaCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetAccountStorageForSencha)

            let objCallData = {
                "Func": "GetAccountStorageForSencha",
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "LessonID": mobjCallParam.LessonID
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetAccountStorageForSencha

    /*===========================================
    summary: 取得舊版使用者 資料 Callback
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function GetAccountStorageForSenchaCallback(Return)
    {
        console.log(COMP_NAME + ".GetAccountStorageForSenchaCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetAccountStorageForSencha_No
        let strErrorTitle = window.gAppUI.ERR_GetAccountStorageForSencha_Title
        let strErrMsg = window.gAppUI.ERR_GetAccountStorageForSencha_Msg

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    // NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg, strRetryBackRoute, blnReLaunch, strBackRoute)
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetAccountStorageForSenchaCallback: ErrNo: ", Return.ErrNo)
            console.log("GetAccountStorageForSenchaCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetAccountStorageForSenchaCallback Return.Data", Return.Data)

            GetAccountStorageForSenchaAfterProcess(Return.Data)
        }
    } // end of GetAccountStorageForSenchaCallback

    /*===========================================
    summary: 儲存舊版使用者 資料
    remarks: 000 Tim 2022/01/10 Create
    ===========================================*/
    function SaveAccountStorageByBase64ForSencha()
    {
        console.log(COMP_NAME + ".SaveAccountStorageByBase64ForSencha: ", props.LUInfo.LUCatSeqNo)

        let objRetryFuncRef = SaveAccountStorageByBase64ForSencha
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = SaveAccountStorageByBase64ForSenchaCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_SaveAccountStorageByBase64ForSencha)

            let objCallData = {
                "Func": "SaveAccountStorageByBase64ForSencha",
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "LessonID": mobjCallParam.LessonID,
                "LUSeqNo": mobjCallParam.LUSeqNo,
                "ActionType": mobjCallParam.ActionType,
                "QList": JSON.stringify(mobjCallParam.QList)
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of SaveAccountStorageByBase64ForSencha

    /*===========================================
    summary: 儲存舊版使用者 資料 Callback
    remarks: 000 Tim 2022/01/10 Create
    ===========================================*/
    function SaveAccountStorageByBase64ForSenchaCallback(Return)
    {
        console.log(COMP_NAME + ".SaveAccountStorageByBase64ForSenchaCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_SaveAccountStorageByBase64ForSencha_No
        let strErrorTitle = window.gAppUI.ERR_SaveAccountStorageByBase64ForSencha_Title
        let strErrMsg = window.gAppUI.ERR_SaveAccountStorageByBase64ForSencha_Msg

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    // NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg, strRetryBackRoute, blnReLaunch, strBackRoute)
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("SaveAccountStorageByBase64ForSenchaCallback: ErrNo: ", Return.ErrNo)
            console.log("SaveAccountStorageByBase64ForSenchaCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("SaveAccountStorageByBase64ForSenchaCallback Return.Data", Return.Data)

            SaveAccountStorageByBase64ForSenchaAfterProcess()
        }
    } // end of SaveAccountStorageByBase64ForSenchaCallback
    // #endregion Web Service

    // #region Component
    // #endregion Component

    // #region Render

    function RenderGoogleClassrommButton()
    {
        let objBlockGoogleClassroomButton = null
        if (!window.gConfig.ForChina)
        {
            // 非China
            if (!window.gSession.App.InApp)
            {
                let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(mstrLUCatSeqNo)
                console.log("strUrl: ", encodeURIComponent(strUrl))            
                objBlockGoogleClassroomButton = <GoogleShareToClassRoom
                    itemType="assignment"
                    url={strUrl}
                    size={32}
                    theme="classic"
                />
            }
            else
            {
                // In App
                console.log("window.gSession.App.AppVersion:", window.gSession.App.AppVersion)
                var intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, "2.0.8.2");
                if(intCheckResult === -1)
                {
                    // DCP iOS App版號 2.0.8.1以前(含) e.g. iOS 2.0.8.1, 2.0.8.0, 2.0.7 ...
                    objBlockGoogleClassroomButton = null
                }
                else
                {
                    // DCP iOS App版號 2.0.8.2以後(含)
                    objBlockGoogleClassroomButton = <div className={cssCanDoStatements.btnShare2GoogleClassroom4App} onClick={() => Share2GoogleClassroom4AppOnTapHandler()} />
                }
            }
        }
        
        return objBlockGoogleClassroomButton
    }

    /*===========================================
    summary: Render QuestionSubRow 的顯示
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function RenderAudioToolAreaWrapper(AudioUrl, QuestionIndex, StateAudioStatusArray)
    {
        if (
            (typeof(AudioUrl) !== 'undefined') &&
            (AudioUrl !== null) &&
            (AudioUrl !== "")
            )
        {
            let objBlock = ""
            if (StateAudioStatusArray[QuestionIndex] === window.gAudioStatusEnum.Stop)
            {
                // window.gAudioStatusEnum.Stop
                objBlock =  <>
                                <div className={cssCanDoStatements.btnAudioPlay} onClick={() => AudioPlayOnTapHandler(AudioUrl, QuestionIndex, StateAudioStatusArray)}/>
                                <div className={cssCanDoStatements.btnAudioStopDisabled}/>
                            </>
            }
            else if (StateAudioStatusArray[QuestionIndex] === window.gAudioStatusEnum.Playing)
            {
                // window.gAudioStatusEnum.Playing
                objBlock =  <>
                                <div className={cssCanDoStatements.btnAudioPause} onClick={() => AudioPauseOnTapHandler(QuestionIndex, StateAudioStatusArray)}/>
                                <div className={cssCanDoStatements.btnAudioStop} onClick={() => AudioStopOnTapHandler(QuestionIndex, StateAudioStatusArray)}/>
                            </>
            }
            else
            {
                // window.gAudioStatusEnum.Paused
                objBlock =  <>
                                <div className={cssCanDoStatements.btnAudioPlay} onClick={() => AudioPlayOnTapHandler(AudioUrl, QuestionIndex, StateAudioStatusArray)}/>
                                <div className={cssCanDoStatements.btnAudioStop} onClick={() => AudioStopOnTapHandler(QuestionIndex, StateAudioStatusArray)}/>
                            </>
            }

            return (
                <div className={cssCanDoStatements.divAudioToolArea}>
                    <div className={cssCanDoStatements.divAudioToolSubArea}>
                        {objBlock}
                    </div>
                    <div className={cssCanDoStatements.btnDelete} onClick={() => DeleteOnTapHandler(QuestionIndex, StateAudioStatusArray)}/>
                </div>
            )
        }
        else
        {
            return (
                <div className={cssCanDoStatements.divAudioToolArea}>
                    <div className={cssCanDoStatements.btnAudioRecord} onClick={() => AudioRecordOnTapHandler(QuestionIndex, StateAudioStatusArray)}/>
                </div>
            )
        }
    } // end of RenderAudioToolAreaWrapper

    /*===========================================
    summary: Render QuestionSubRow 的顯示
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function RenderQuestionSubRowWrapper(QuestionData, QuestionIndex)
    {
        return (
            <div className={cssCanDoStatements.divQuestionSubRow}>
                <div className={GetCheckedIconCls(QuestionData.AudioUrl)}/>
                <div className={cssCanDoStatements.divQuestionText}>
                    {QuestionData.QuestionText}
                </div>
                {RenderAudioToolAreaWrapper(QuestionData.AudioUrl, QuestionIndex, audioStatusArray)}
            </div>
        )
    } // end of RenderQuestionSubRowWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <div className={cssCanDoStatements.divContent}>
                <div className={cssCanDoStatements.divQuestionArea}>
                    {marrDisplayQuestion.map((QuestionData, QuestionIndex) => 
                        <div key={QuestionIndex} className={cssCanDoStatements.divQuestionRow}>
                            {RenderQuestionSubRowWrapper(QuestionData, QuestionIndex)}

                            <div className={cssCanDoStatements.divQuestionRowLine}/>
                        </div>
                    )}
                </div>
            </div>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render Title 區域 的顯示
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function RenderTitleAreaWrapper()
    {
        return (
            <div className={cssCanDoStatements.divTitleArea}>
                <div className={cssCanDoStatements.divLessonIcon}/>

                <div className={cssCanDoStatements.divLUTitleTextEN}>
                    {props.SubSectionDef.Name}
                </div>

                <div className={cssCanDoStatements.divDividerBar}/>

                <div className={cssCanDoStatements.divLUTitleTextCN}>
                    {mstrSubSectionTitleCN}
                </div>
            </div>
        )
    } // end of RenderHeaderWrapper

    /*===========================================
    summary: Render Header 的顯示
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function RenderHeaderWrapper()
    {
        return (
            <div className={cssCanDoStatements.divHeaderArea}>
                <div className={cssCanDoStatements.divHeaderSubArea}>
                    {RenderGoogleClassrommButton()}
                    
                    {RenderTitleAreaWrapper()}
                </div>

                <div className={cssCanDoStatements.divInstructionArea}>
                    {props.LUInfo.Instruction}
                </div>
            </div>
        )
    } // end of RenderHeaderWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2022/01/07 Create
    ===========================================*/
    function RenderMainWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssCanDoStatements.divMain}>
                    {RenderHeaderWrapper()}
                    {RenderContentWrapper()}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderMainWrapper

    return (
        <>        
            {RenderMainWrapper(updateDataTime)}
        </>
    )
    // #endregion Render
}
export default CanDoStatements